// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__p1aUG","footer":"ModalFilter_footer__1Ue8G"};